// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e6584cb4","455":"5429412b","672":"3c7ca941","726":"453ac3f1"}[chunkId] + ".chunk.js";
};